module.exports = __webpack_public_path__ + "static/media/3_Ensure-Correct-Wall-Recess-Size-TooLarge.9065774a.svg";